import { useEffect, useRef, useState } from "react";
import { useChatSupportActiveMessages } from "../../../context/chat-support/chat-support-active-chat.context";
import { useIntersectionObserver } from "../../../customHooks/useIntersectionOpserver";
import { FaArrowCircleDown } from "react-icons/fa";
import { Badge } from "../../shared/atoms/badge";
import { scrollToBottom } from "../../../utils/util";

export const NewMsgScrollHelper = () => {
  const { ref, isIntersecting } = useIntersectionObserver();
  const [showButton, setShowButton] = useState(false);
  const {
    states: {
      messages: { msgsContainerRef, setNewRecivedMessagesCount, newRecivedMessagesCount },
    },
  } = useChatSupportActiveMessages();

  const handleButtonClick = () => {
    scrollToBottom(msgsContainerRef);
    resetStates();
  };
  const resetStates = () => {
    setShowButton(false);
    setNewRecivedMessagesCount(0);
  };

  useEffect(() => {
    if (isIntersecting && showButton) {
      resetStates();
      return;
    }
    if (newRecivedMessagesCount && !isIntersecting) setShowButton(true);
  }, [isIntersecting, newRecivedMessagesCount, showButton]);
  return (
    <>
      <button
        onClick={handleButtonClick}
        className={`fixed end-10   bottom-20 ${showButton ? "w-fit z-20 opacity-1 h-auto" : "w-0 h-0 opacity-0"}`}
      >
        <Badge className="px-1 py-0 font-bold" color="red">
          {newRecivedMessagesCount}
        </Badge>
        <FaArrowCircleDown className=" text-2xl text-gray-600" />
      </button>
      <div ref={ref}></div>
    </>
  );
};
